import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { View } from '@zhike/ti-ui';
import { Audio } from '@zhike/ti-component';
import { cdnUrl } from 'common/config';
import RawAndFlag from 'components/repeat/content/raw_and_flag';
import Pronounce from 'components/repeat/content/pronounce';
import RenderIndex from 'components/report/common/render_index';
import { handlePractice } from 'components/listen/utils';
import styles from './styles';


export default class Report extends Component {
  static propTypes = {
    questions: PropTypes.array.isRequired,
    question: PropTypes.object.isRequired,
    practice: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.practice = handlePractice({
      practice: {
        data: this.props.practice,
      },
    })
  }

  componentDidUpdate(prevProps) {
    if (prevProps.question !== this.props.question) {
      const element = global.document.querySelector('#right')
      if (element) element.scrollTop = 0
    }
  }

  getRaw() {
    try {
      const { question } = this.props
      let raw = get(question, 'materials.0.userAnswer.answer.transcript')

      if (!raw) {
        const { questionId } = this.props.match.params
        const questionPart = this.practice.questionParts.find(item => item.id === +questionId)

        raw = questionPart.translation[0].raw // eslint-disable-line
      }

      return raw
    } catch (e) {
      console.error(e)
      return ''
    }
  }

  render() {
    const { questions, question, match } = this.props
    const direction = get(question, 'materials.0.direction.paragraphs.0.text')
    const raw = this.getRaw()
    const answer = get(question, 'materials.0.userAnswer')
    const originAudio = get(question, 'materials.0.audio.src')
    const userAudio = get(question, 'materials.0.userAnswer.answer.audioUrl')

    return (
      <View className={styles.container}>
        <View className={styles.left}>
          <View className={styles.width}>
            <RenderIndex questions={questions} question={question} match={match} />
            <View className={styles.direction}>{direction}</View>
            <View className={styles.raw}>{raw}</View>
          </View>
        </View>
        <View className={styles.right} id="right">
          <View className={styles.width}>
            <View className={styles.marginBottom}>
              <View className={styles.title}>
                <View className={styles.icon}></View>
                <View className={styles.text}>句子原文</View>
              </View>
              <RawAndFlag raw={raw} answer={answer} active />
            </View>

            {
              originAudio &&
              <View className={styles.marginBottom}>
                <View className={styles.title}>
                  <View className={styles.icon}></View>
                  <View className={styles.text}>原文音频</View>
                </View>
                <Audio src={originAudio} progressWidth={348} cdnUrl={cdnUrl} />
              </View>
            }

            {
              userAudio &&
              <View className={styles.marginBottom}>
                <View className={styles.title}>
                  <View className={styles.icon}></View>
                  <View className={styles.text}>我的发音</View>
                </View>
                <Audio src={userAudio} progressWidth={348} cdnUrl={cdnUrl} />
              </View>
            }

            {
              answer &&
              <Pronounce answer={answer} dashedHeader />
            }
          </View>
        </View>
      </View>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/report/base_report/follow_up_report/index.js